export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return;

  // We manually filter and close/remove instead of ElNotification.closeAll()
  // to avoid clearing fresh notifications from embedded apps

  // Manually remove any lingering notification elements from the DOM
  // This is necessary for notifications generated by embedded apps (like cm-reports)
  // which run in a separate Vue instance/context but share the same document body.
  const notifications = document.querySelectorAll(".el-notification");
  notifications.forEach((notification) => {
    // Check for timestamp from MutationObserver (works for embedded apps too)
    const timestamp = (notification as HTMLElement).dataset.timestamp;

    if (timestamp) {
      const created = parseInt(timestamp, 10);
      if (Date.now() - created < 1000) {
        return;
      }
    }

    notification.remove();
  });
});
